<script>
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import ZaloOaChannel from 'dashboard/api/channel/zaloOaChannel';

export default {
  components: { PageHeader, NextButton },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return { inboxName: '', loading: false };
  },
  validations: { inboxName: { required } },
  methods: {
    async authorize() {
      this.v$.$touch();
      if (this.v$.$invalid) return;
      this.loading = true;
      try {
        const { data } = await ZaloOaChannel.authorizeUrl(this.inboxName);
        window.location.href = data.authorize_url;
      } catch (error) {
        this.loading = false;
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.ZALO_OA.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.ZALO_OA.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.ZALO_OA.DESC')"
    />
    <form class="flex flex-wrap flex-col mx-0" @submit.prevent="authorize()">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.ZALO_OA.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.ZALO_OA.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
      </label>
      <div class="w-full mt-4">
        <NextButton
          :is-loading="loading"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.ZALO_OA.AUTHORIZE_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
